import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

export default function GlobalFilters({ filters, setFilters, config, uniqueSkus }) {
  // Filter SKUs based on selected vertical
  const filteredSkus = filters.vertical && filters.vertical !== "all"
    ? (config?.sku_mapping?.[filters.vertical] || [])
    : uniqueSkus;

  return (
    <div className="flex items-center gap-4 mb-6 p-3 bg-slate-50 rounded border border-slate-200 flex-wrap" data-testid="global-filters">
      {/* Vertical Filter */}
      <div className="flex items-center gap-2">
        <Label className="text-xs text-slate-600">Vertical:</Label>
        <Select value={filters.vertical || "all"} onValueChange={(v) => setFilters(f => ({ ...f, vertical: v, sku: "all" }))}>
          <SelectTrigger className="w-[130px] h-8 text-sm" data-testid="filter-vertical">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Verticals</SelectItem>
            {config?.verticals?.map(v => <SelectItem key={v} value={v}>{v}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {/* SKU Filter */}
      <div className="flex items-center gap-2">
        <Label className="text-xs text-slate-600">SKU:</Label>
        <Select value={filters.sku || "all"} onValueChange={(v) => setFilters(f => ({ ...f, sku: v }))}>
          <SelectTrigger className="w-[140px] h-8 text-sm" data-testid="filter-sku">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All SKUs</SelectItem>
            {filteredSkus.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {/* Blocker Toggle */}
      <div className="flex items-center gap-2">
        <Switch
          id="blockers-only"
          checked={filters.blockersOnly || false}
          onCheckedChange={(v) => setFilters(f => ({ ...f, blockersOnly: v }))}
          data-testid="filter-blockers"
        />
        <Label htmlFor="blockers-only" className="text-xs text-slate-600 cursor-pointer">Blockers Only</Label>
      </div>

      {/* Sort */}
      <div className="flex items-center gap-2">
        <Label className="text-xs text-slate-600">Sort:</Label>
        <Select value={filters.sortBy || "deadline"} onValueChange={(v) => setFilters(f => ({ ...f, sortBy: v }))}>
          <SelectTrigger className="w-[150px] h-8 text-sm" data-testid="filter-sort">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="deadline">Deadline (ASC)</SelectItem>
            <SelectItem value="blockers">Blockers (DESC)</SelectItem>
            <SelectItem value="updated">Last Updated</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Clear Filters */}
      {(filters.vertical !== "all" || filters.sku !== "all" || filters.blockersOnly) && (
        <button
          onClick={() => setFilters({ vertical: "all", sku: "all", blockersOnly: false, sortBy: "deadline", dateFrom: "", dateTo: "" })}
          className="text-xs text-blue-600 hover:underline" data-testid="clear-filters-btn"
        >Clear Filters</button>
      )}
    </div>
  );
}
